import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 42272 59589"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#343230}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <path
        d="m2048 29763 721 3976c1615 8881 9340 15328 18368 15328 9026 0 16750-6447 18365-15327l722-3977H2048zm19089 21167c-9928 0-18424-7090-20199-16857L15 29000c-48-272 25-554 201-764 178-213 438-334 716-334h40410c273 0 535 122 712 334 177 210 251 490 203 764l-923 5073c-1776 9767-10271 16857-20197 16857z"
        className="fil0"
      />
      <path
        d="M35570 59589H6705c-318 0-615-163-786-431-170-268-194-604-61-889l5091-11031c214-464 769-669 1235-453 466 215 670 767 455 1236l-4479 9705h25951l-4479-9705c-213-469-12-1021 457-1236 464-216 1017-11 1234 453l5089 11031c135 285 111 621-60 889s-467 431-782 431zM7635 27902h27003V5711H7635v22191zm27935 1861H6705c-515 0-930-417-930-930V4779c0-515 414-931 930-931h28865c511 0 928 417 928 931l1 24054c0 513-418 930-930 930h1z"
        className="fil0"
      />
      <path
        d="M3788 3848h34698V1861H3788v1987zm35629 1863H2857c-517 0-932-417-932-932V932c0-515 415-932 932-932h36560c515 0 931 418 931 932l1 3847c0 515-418 932-932 932zM29795 9558c-548 0-993 446-993 994s445 993 993 993 993-445 993-993c0-549-445-994-993-994zm0 3850c-1575 0-2855-1283-2855-2856s1280-2854 2855-2854c1573-1 2856 1281 2856 2854s-1283 2856-2856 2856z"
        className="fil0"
      />
      <path
        d="M38455 11482h-6736c-515 0-931-416-931-930 0-513 415-930 931-930h6350l1650-1653c365-363 953-363 1317 0 364 364 363 954 0 1317l-1924 1925c-174 172-411 272-657 271z"
        className="fil0"
      />
    </g>
  </svg>
)
export default SvgComponent
